// IMPORT:
var UTILS = require(/*! ../libs/utils.js */"../libs/utils.js");
var config = require(/*! ../config.js */"../config.js");

// PROJECTILE OBJECT:
function Projectile() {
  // INIT:
  this.init = function (x, y, z, xD, yD, data, owner) {
    this.x = x;
    this.y = y;
    this.z = z;
    xD -= Math.PI;
    this.xD = xD;
    this.yD = yD;
    this.spd = data.spd;
    this.range = data.range;
    this.dmg = data.dmg;
    this.owner = owner;
    this.skipMove = true;
    this.expl = data.explode;
    this.xS = this.spd * Math.sin(xD) * Math.cos(yD);
    this.zS = this.spd * Math.cos(xD) * Math.cos(yD);
    this.yS = this.spd * Math.sin(yD);
    this.active = true;
  };

  // UPDATE:
  this.update = function (delta) {
    if (this.active) {
      if (this.skipMove) {
        this.skipMove = false;
      } else {
        this.x += this.xS * delta;
        this.z += this.zS * delta;
        this.y += this.yS * delta;
        this.range -= this.spd * delta;
        if (this.range <= 0) {
          this.active = false;
        }
      }
    }
  };
} // PROJECTILE MANAGER:
module.exports = function (game, io) {
  // INIT:
  var THREE = io ? {} : require("three");
  var tmpObj;
  var tmpObj2;
  var tmpList = [];
  this.projectiles = [];
  this.types = [{
    mat: THREE.MeshBasicMaterial,
    color: 0xffffdb,
    explode: 50,
    dmg: 125,
    spd: 0.5,
    scale: 1.4,
    length: 10,
    range: 600
  }, {
    mat: THREE.MeshBasicMaterial,
    color: 0xffffdb,
    dmg: 200,
    spd: 0.68,
    scale: 0.7,
    length: 10,
    range: 1000
  }];

  // UPDATE:
  this.update = function (delta) {
    for (var i = 0; i < this.projectiles.length; ++i) {
      tmpObj = this.projectiles[i];
      if (tmpObj.active) {
        tmpObj.update(delta);
        if (tmpObj.active) {
          tmpList.length = 0;
          var dx = 1 / (tmpObj.spd * delta * Math.sin(tmpObj.xD) * Math.cos(tmpObj.yD));
          var dz = 1 / (tmpObj.spd * delta * Math.cos(tmpObj.xD) * Math.cos(tmpObj.yD));
          var dy = 1 / (tmpObj.spd * delta * Math.sin(tmpObj.yD));

          // OBJECTS:
          for (var x = 0; x < game.map.manager.objects.length; ++x) {
            tmpObj2 = game.map.manager.objects[x];
            if (!tmpObj2.noShoot && tmpObj2.active) {
              tmpDst = UTILS.lineInRect(tmpObj.x, tmpObj.z, tmpObj.y, dx, dz, dy, tmpObj2.x - tmpObj2.width, tmpObj2.z - tmpObj2.length, tmpObj2.y - tmpObj2.height, tmpObj2.x + tmpObj2.width, tmpObj2.z + tmpObj2.length, tmpObj2.y + tmpObj2.height);
              if (tmpDst && tmpDst <= 1) {
                tmpList.push({
                  obj: tmpObj2,
                  dst: tmpDst
                });
              }
            }
          }

          // PLAYERS:
          for (var x = 0; x < game.players.list.length; ++x) {
            tmpObj2 = game.players.list[x];
            if (tmpObj2.active && tmpObj2 != tmpObj.owner) {
              tmpDst = UTILS.lineInRect(tmpObj.x, tmpObj.z, tmpObj.y, dx, dz, dy, tmpObj2.x - tmpObj2.scale - config.hitBoxPad, tmpObj2.z - tmpObj2.scale - config.hitBoxPad, tmpObj2.y, tmpObj2.x + tmpObj2.scale + config.hitBoxPad, tmpObj2.z + tmpObj2.scale + config.hitBoxPad, tmpObj2.y + tmpObj2.height + config.hitBoxPad);
              if (tmpDst && tmpDst <= 1) {
                tmpList.push({
                  plr: true,
                  obj: tmpObj2,
                  dst: tmpDst
                });
              }
            }
          }

          // TERRAIN:
          var terrain = game.map.terrain;
          if (terrain) {
            var terrainRaycast = terrain.raycast(tmpObj.x, -tmpObj.z, tmpObj.y, 1 / dx, -1 / dz, 1 / dy);
            if (terrainRaycast) {
              let dst = UTILS.getDistance3D(tmpObj.x, tmpObj.y, tmpObj.z, terrainRaycast.x, terrainRaycast.z, -terrainRaycast.y);
              tmpList.push({
                dst: dst / tmpObj.range
              });
            }
          }

          // DESTROY:
          if (tmpList.length) {
            tmpList.sort(UTILS.orderByNum);
            if (tmpList[0]) {
              if (tmpList[0].obj && tmpList[0].plr && game.players.changeHealth(tmpList[0].obj, tmpObj.owner, tmpObj.dmg)) {
                game.players.kill(tmpList[0].obj, tmpObj.owner, {});
              }
              tmpObj.x += tmpList[0].dst * (tmpObj.xS * delta);
              tmpObj.y += tmpList[0].dst * (tmpObj.yS * delta);
              tmpObj.z += tmpList[0].dst * (tmpObj.zS * delta);
            }
            tmpObj.active = false;
          }
        }
        if (!tmpObj.active) {
          if (tmpObj.expl) {
            game.explosion(tmpObj.x, tmpObj.y, tmpObj.z, tmpObj.expl, tmpObj.dmg, tmpObj.owner);
          }
          for (var x = 0; x < game.players.list.length; ++x) {
            io.send(game.players.list[x].id, "pre", tmpObj.sid);
          }
        }
      }
    }
  };

  // INIT:
  this.init = function (x, y, z, xD, yD, index, owner) {
    x = x.round(1);
    y = y.round(1);
    z = z.round(1);
    xD = xD.round(3);
    yD = yD.round(3);
    tmpObj = null;
    for (var i = 0; i < this.projectiles.length; ++i) {
      if (!this.projectiles[i].active) {
        tmpObj = this.projectiles[i];
        break;
      }
    }
    if (!tmpObj) {
      tmpObj = new Projectile();
      tmpObj.sid = this.projectiles.length;
      this.projectiles.push(tmpObj);
    }
    tmpObj.init(x, y, z, xD, yD, this.types[index], owner);
    if (io) {
      for (var i = 0; i < game.players.list.length; ++i) {
        if (game.players.list[i].active || game.players.list[i].spectating) {
          io.send(game.players.list[i].id, "pr", x, y, z, xD, yD, index, tmpObj.sid);
        }
      }
    }
  };
};